import { Component, Input, OnInit } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';

import { StepIndicatorService } from './stepindicator.service';
import { StepIndicatorModel } from './stepindicator.model';

@Component({
  selector: 'app-stepindicator',
  styleUrls: ['./stepindicator.component.scss'],
  templateUrl: './stepindicator.component.html'
})

export class StepIndicatorComponent implements OnInit {
  @Input() stepIndicators: StepIndicatorModel[];
  currentStep: string = '';
  @Input() displayIndicator: boolean;
  @Input() sessionName: string;


  constructor(protected router: Router, protected stepindicatorService: StepIndicatorService) {
    this.displayIndicator = true;
  }

  ngOnInit() {
    let currentStepnum;
    this.stepindicatorService.getCurrentStep().subscribe(
      (path: string) => {
        this.currentStep = path;
        for (const step of this.stepIndicators) {
          if (step.path === path) {
            currentStepnum = step.stepNumber;
            step.isVisited = true;
            this.stepindicatorService.setSteps(this.stepIndicators, this.sessionName);
          }

          if(step.stepNumber > currentStepnum){
            step.isVisited = false;
            this.stepindicatorService.setSteps(this.stepIndicators, this.sessionName);
          }
        }
      }
    );
    this.stepindicatorService.getVisibility().subscribe(
      (status: boolean) => {
        this.displayIndicator = status;
      }
    );
  }
}
